<template>
  <div>
    <!-- 标签匹配 -->
    <el-dialog :title="$t('message.tagMatching')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="480px" center>
      <!-- 匹配上传 -->
      <div class="content" v-if="isNormal">
        <!-- 标签类别 -->
        <div class="row">
          <div class="label">
            {{ $t("message.tagType") }} ：
          </div>
          <div class="val">
            <el-select v-model="datas.type" placeholder="请选择" filterable>
              <el-option v-for="item in options" :key="item.value" :label="item.key" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <!-- text文件 -->
        <div class="row">
          <div class="label">text文件 ：</div>
          <div class="val">
            <el-upload class="upload-demo" drag :action="baseURL + '/api/common/uploadFile'" :show-file-list="false"
              :before-upload="beforeAvatarUpload" :on-success="handleAvatarSuccess" multiple>
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>
            </el-upload>
          </div>
        </div>
      </div>
      <!-- 匹配完成 -->
      <div class="normal" v-else>
        <div v-for="(item, index) in textList" :key="index">
          {{ item }}
        </div>
      </div>
      <!-- 匹配上传 -->
      <span slot="footer" class="dialog-footer" v-if="isNormal">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">
          {{ $t("message.ok") }}
        </el-button>
      </span>
      <!-- 匹配完成 -->
      <span slot="footer" class="dialog-footer" v-else>
        <!--取 消  -->
        <el-button type="success" @click="copyText">{{ $t("message.copy") }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="dialogVisible = false">
          {{ $t("message.ok") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    selectedList: { type: Array },
  },
  data() {
    return {
      options: [
        { key: "亚马逊FBA", value: "FBA" },
        { key: "乐天", value: "LETIAN" },
        { key: "雅虎", value: "YAHU" },
        { key: "ZOZO", value: "ZOZO" },
      ],
      datas: {
        type: "",
        file_path: "",
        porder_detail_id_set: [],
      },
      porder_sn: this.$route.query.porder_sn, //配送单号
      dialogVisible: false,
      isNormal: true,// 是否上传匹配
      textList: [],
    };
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible) {
        this.isNormal = true
      }
    },
  },
  methods: {
    // 保存
    save() {
      this.datas.porder_detail_id_set = [];
      this.selectedList.forEach((item) => {
        this.datas.porder_detail_id_set.push(item.id);
      });
      if (!this.datas.type) return this.$message.error("未选择标签列表 ");
      if (!this.datas.file_path) return this.$message.error("未上传标签文件 ");

      this.$api.porderApi.textMatch(this.datas).then((res) => {

        this.$store.dispatch("porderDetail", { porder_sn: this.porder_sn });
        this.datas = {
          file_path: "",
          type: "",
          porder_detail_id_set: [],
        };
        this.$parent.selectedList = [];
        this.$parent.checked = false;
        if (res.data == false) return false
        this.textList = res.data
        this.isNormal = false

      });
    },
    // 上传前
    beforeAvatarUpload(file) {
      const isText = file.type === "text/plain";
      const isXlsm = file.name.split(".")[1] === "xlsm"
      if (!isText && !isXlsm) {
        this.$message.error("上传格式只能是text/plain,xlsm!");

      }
      return isText || isXlsm;
    },
    //添加修改图片
    handleAvatarSuccess(file) {
      this.datas.file_path = file.data;
      this.$message.success("上传成功");
    },
    //复制
    copyText() {
      let text = ''
      this.textList.forEach(item => {
        text += item + '\n'
      })
      this.copy(text)
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;

  .row {
    display: flex;
    margin-bottom: 20px;

    .label {
      line-height: 40px;
      flex: 1;
    }

    .val {
      flex: 3;
    }
  }

  /deep/.el-select {
    .el-input {
      width: 100%;
    }

    width: 80%;
  }

  /deep/.el-upload-dragger {
    width: 250px;
  }
}

.normal {
  max-height: 500px;
  overflow-y: auto;

  div {
    margin-bottom: 5px;
  }
}
</style>